module.exports = __webpack_public_path__ + "static/img/Bachelor_010696.1695ff0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Bachelor_010696.jpg
// module id = 222
// module chunks = 0